export type OrganisationLoginInfo = {
  loginMethods?: string[] | null;
  loginMethodsCheck?: string[] | null;
  loginLogos?: string[] | null;
};

const defaultMethods = ['google', 'facebook', 'linkedin', 'microsoft'];

export function availableLoginMethods(info?: OrganisationLoginInfo | null) {
  if (info?.loginMethodsCheck?.length) {
    const methods = info.loginMethodsCheck.filter(
      (method) => !method.startsWith('xapi')
    );
    return {
      useLocalLogin: methods.includes('local'),
      loginMethods: methods.filter((method) => method !== 'local'),
    };
  }

  if (info?.loginMethods?.length) {
    const loginMethods = [...defaultMethods];
    for (const method of info.loginMethods) {
      if (
        method !== 'local' &&
        !method.startsWith('xapi') &&
        !loginMethods.includes(method)
      ) {
        loginMethods.unshift(method);
      }
    }
    return {
      useLocalLogin: info.loginMethods.includes('local'),
      loginMethods,
    };
  }

  return { useLocalLogin: true, loginMethods: defaultMethods };
}

export function loginMethodLogo(
  info: OrganisationLoginInfo | null,
  method: string
) {
  const index = info?.loginMethods?.indexOf(method) ?? -1;
  return index >= 0 ? info?.loginLogos?.[index] : undefined;
}
